'use strict';

require('../../style/css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/modal/style/css.js
// module id = 367
// module chunks = 124